// extracted by mini-css-extract-plugin
export default {"primaryColor":"#001f60","secondaryColor":"#ce0e2d","successColor":"#28c76f","infoColor":"#590707","warningColor":"#f90","dangerColor":"red","textColor":"#5b6670"};